import { render, staticRenderFns } from "./BranchRoles.vue?vue&type=template&id=5cbe3018&"
import script from "./BranchRoles.vue?vue&type=script&lang=js&"
export * from "./BranchRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports